import { Component } from '@angular/core';
import { UserService } from 'src/app/core/common-services/user.services';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent {

  constructor(private userService: UserService) { }

  ngOnInit() {
    if (!this.userService.isLoggedIn())
    this.userService.logout()
}
}
